import { supabase } from "@/integrations/supabase/client";

const db = supabase as any;

export async function logFrontendError(
  source: string,
  message: string,
  metadata?: Record<string, unknown>
) {
  try {
    await db.from("frontend_error_logs").insert({
      source,
      message,
      metadata: metadata ?? {},
    });
  } catch {
    // Silent fail — don't break the app because of logging
  }
}
